import { render, staticRenderFns } from "./CoverCreateView.vue?vue&type=template&id=aabd59c8&"
import script from "./CoverCreateView.vue?vue&type=script&lang=js&"
export * from "./CoverCreateView.vue?vue&type=script&lang=js&"
import style0 from "./CoverCreateView.vue?vue&type=style&index=0&id=aabd59c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports